import React from 'react'
import styled from 'styled-components';

import noorLogo from '../../assets/noorLogo.png'

const Logo = ({ height, width }) => {
  return (
    <AppLogo alt='logo' src={noorLogo} height={height} width={width} />
  )
}

const AppLogo = styled.img`
  height: ${props => props.height}rem;
  width: ${props => props.width}rem;
`;

export default Logo;